// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_71-4";
export var collapsed = "_71-1";
export var headerBar = "_71-0";
export var leftHeaderContent = "_71-3";
export var subjectContainer = "_71-2";